<table class="table table-hover table-striped" [class.dim]="!crud.complete">
    <thead>
        <tr>
            <th>Product</th>
            <th>Quantity</th>
            <th class="text-end">Total</th>
            <th></th>
        </tr>
    </thead>
    @if (response) {
        <tbody>
            @for (item of cartHelpers.groupLineItems(response.data) | keyvalue; track item) {
                <tr>
                    <td class="col-3">
                        <b>{{ item.value[0].productLabel }}:</b> {{ item.value[0].productDescription }}
                    </td>
                    <td class="col-3 text-start">{{ item.value.length }}</td>
                    <td class="col-2 text-end">${{ cartHelpers.lineItemSubtotal(item.value[0].price, item.value.length) }}</td>
                    <td class="text-center">
                        <div class="btn btn-sm btn-primary" (click)="deleteLineItem(item.value[0].order.id, item.value[0].productId)">Remove</div>
                    </td>
                </tr>
            }
        </tbody>
    }
</table>
@if (response) {
    <div class="btn btn-sm btn-primary" (click)="deleteAllLineItems(cartHelpers.getOrderId(response.data))">Empty cart</div>
}
